import { ref } from 'vue'

export const pronunciationOwner = ref(null)
let player = null
let utterance = null
let generation = 0

export function stopPronunciation(owner) {
  if (owner !== undefined && pronunciationOwner.value !== owner) return
  generation++
  if (player) { player.pause(); player.src = ''; player = null }
  if (utterance && 'speechSynthesis' in window) window.speechSynthesis.cancel()
  utterance = null
  pronunciationOwner.value = null
}

async function englishVoice() {
  const synth = window.speechSynthesis
  const choose = () => synth.getVoices().find(voice => voice.lang.toLowerCase() === 'en-gb')
    || synth.getVoices().find(voice => voice.lang.toLowerCase().startsWith('en'))
  let voice = choose()
  if (voice) return voice
  await new Promise(resolve => {
    const finish = () => { clearTimeout(timer); synth.removeEventListener('voiceschanged', finish); resolve() }
    const timer = setTimeout(finish, 1200)
    synth.addEventListener('voiceschanged', finish)
  })
  return choose()
}

export async function pronounce(owner, term, phonetics = [], onError = () => {}) {
  stopPronunciation()
  const attempt = generation
  pronunciationOwner.value = owner
  const audioUrl = phonetics.find(item => item.audio?.startsWith('https://'))?.audio
  if (audioUrl) {
    player = new Audio(audioUrl)
    const current = player
    current.onended = () => { if (generation === attempt) stopPronunciation(owner) }
    try {
      await current.play()
      if (generation !== attempt) { current.pause(); return }
      return
    } catch {
      if (generation !== attempt) return
      current.pause()
      player = null
    }
  }
  if (!('speechSynthesis' in window) || !('SpeechSynthesisUtterance' in window)) {
    stopPronunciation(owner)
    throw new Error('Thiết bị chưa hỗ trợ đọc tiếng Anh.')
  }
  const voice = await englishVoice()
  if (generation !== attempt) return
  if (!voice) {
    stopPronunciation(owner)
    throw new Error('Thiết bị chưa có giọng tiếng Anh. Hãy thử trên thiết bị có giọng đọc tiếng Anh.')
  }
  // Lesson audio and vocabulary audio share the browser speech queue.
  window.speechSynthesis.cancel()
  window.speechSynthesis.resume()
  utterance = new SpeechSynthesisUtterance(term)
  utterance.lang = voice.lang
  utterance.voice = voice
  utterance.rate = 0.85
  utterance.onend = () => { if (generation === attempt) stopPronunciation(owner) }
  utterance.onerror = event => {
    if (generation === attempt) {
      stopPronunciation(owner)
      if (!['canceled', 'interrupted'].includes(event.error)) onError('Chưa phát được âm thanh. Em thử nghe lại nhé.')
    }
  }
  window.speechSynthesis.speak(utterance)
}
